import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="staff-payment"
export default class extends Controller {
  static values = {
    paymentId: String,
    amount: String
  }
  
  connect() {
    // Initialize controller
  }
  
  openModal() {
    // Get the modal element
    const modal = document.getElementById('staff-payment-modal')
    if (!modal) return

    // Set the payment ID in the form
    const paymentIdField = document.getElementById('payment-id-field')
    if (paymentIdField) {
      paymentIdField.value = this.paymentIdValue
    }

    // Set the payment amount in the display
    const amountDisplay = document.getElementById('payment-amount-display')
    if (amountDisplay) {
      amountDisplay.textContent = this.amountValue
    }

    // Show the modal
    modal.classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
  }
  
  close() {
    const modal = document.getElementById('staff-payment-modal')
    if (modal) {
      modal.classList.add('hidden')
      document.body.classList.remove('overflow-hidden')
    }
  }
}
